import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import AccountmasterViewPage from 'pages/accountmaster/View';
import LoanproductViewPage from 'pages/loanproduct/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const GrouploancontractListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		groupid: {
			tagTitle: $t('groupid'),
			value: '',
			valueType: 'single',
			options: [],
		},
		disbursementdate: {
			tagTitle: $t('disbursementDate'),
			value: [],
			valueType: 'range-date',
			options: [],
		},
		ac_closed: {
			tagTitle: $t('acClosed'),
			value: '',
			valueType: 'single',
			options: app.menus.acClosed2,
		},
		date_closed: {
			tagTitle: $t('dateClosed'),
			value: [],
			valueType: 'range-date',
			options: [],
		},
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	// return sum of loanamount for the current records
	const totalLoanamount = utils.sum(records, 'loanamount');
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/grouploancontract/view/${data.loanaccountno}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('grouploancontract/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/grouploancontract/edit/${data.loanaccountno}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('grouploancontract/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.loanaccountno) },
			icon: "pi pi-trash",
			visible: () => auth.canView('grouploancontract/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<Link to={`/grouploancontract/view/${data.loanaccountno}`}> { data.loanaccountno }</Link>
			);
		}
	}
	function LoanproductidTemplate(data){
		if(data){
			return (
				<>{data.loanproductid && <Button className="p-button-text" icon="pi pi-eye" label={$t('loanproduct')} onClick={() => app.openPageDialog(<LoanproductViewPage isSubPage apiPath={`/loanproduct/view/${data.loanproductid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function DatecontractstartsTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.datecontractstarts )}</>
			);
		}
	}
	function DatecontractendsTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.datecontractends )}</>
			);
		}
	}
	function DisbursementdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.disbursementdate )}</>
			);
		}
	}
	function FirstEmiDateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.first_emi_date )}</>
			);
		}
	}
	function AcCodeTemplate(data){
		if(data){
			return (
				<>{data.ac_code && <Button className="p-button-text" icon="pi pi-eye" label={$t('accountmaster')} onClick={() => app.openPageDialog(<AccountmasterViewPage isSubPage apiPath={`/accountmaster/view/${data.ac_code}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function MembernameTemplate(data){
		if(data){
			return (
				<>{ data.lookupmemvw_membername }</>
			);
		}
	}
	function GroupnameTemplate(data){
		if(data){
			return (
				<>{ data.lookupmemvw_groupname }</>
			);
		}
	}
	function EmpnameTemplate(data){
		if(data){
			return (
				<>{ data.lookupmemvw_empname }</>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{ data.lookupmemvw_userid }</>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-grouploancontract`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="grouploancontract/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="GrouploancontractListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('loanContract')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <Link to={`/grouploancontract/index`}>
                        <Button label={$t('approve')} icon="pi pi-check-square" type="button" className="p-button w-full bg-primary-color "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('groupid', options)}  apiPath="components_data/groupid_option_list_3"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'groupid', e.value)} value={filters.groupid.value} optionLabel="label" optionValue="value" options={filters.groupid.options} placeholder={$t('selectAGroup')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.disbursementdate.value} onChange={(e) => setFilterValue('disbursementdate', e.value)} placeholder={$t('selectDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'ac_closed', e.value)} value={filters.ac_closed.value} optionLabel="label" optionValue="value" options={filters.ac_closed.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.date_closed.value} onChange={(e) => setFilterValue('date_closed', e.value)} placeholder={$t('selectDateClosed')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-fixed " >
                        <Link to={`/grouploancontract/add`}>
                            <Button label={$t('addNewLoan')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            }
            <section className="page-section " >
                <div className="container-fluid">
                    <div className="grid ">
                        <div className="col comp-grid" >
                            <FilterTags filterController={filterController} />
                            <div >
                                <PageBreadcrumbs />
                                <div className="grid ">
                                    <div className="col">
                                        <div className="page-records">
                                            <DataTable 
                                                lazy={true} 
                                                loading={loading} 
                                                selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                                value={records} 
                                                dataKey="loanaccountno" 
                                                sortField={sortBy} 
                                                sortOrder={sortOrder} 
                                                onSort={onSort}
                                                className=" p-datatable-sm" 
                                                stripedRows={true}
                                                showGridlines={false} 
                                                rowHover={true} 
                                                responsiveLayout="stack" 
                                                emptyMessage={<EmptyRecordMessage />} 
                                                >
                                                {/*PageComponentStart*/}
                                                <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                                <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                                <Column  field="loanaccountno" header={$t('loanAccountno')} body={LoanaccountnoTemplate} sortable={true} ></Column>
                                                <Column  field="groupid" header={$t('groupId')}  sortable={true} ></Column>
                                                <Column  field="memberid" header={$t('memberId')}  sortable={true} ></Column>
                                                <Column  field="branchcode" header={$t('branchCode')}  sortable={true} ></Column>
                                                <Column  field="loanproductid" header={$t('loanProductid')} body={LoanproductidTemplate} sortable={true} ></Column>
                                                <Column  field="loan_type" header={$t('loanType')}  sortable={true} ></Column>
                                                <Column  field="datecontractstarts" header={$t('dateContractStart')} body={DatecontractstartsTemplate} sortable={true} ></Column>
                                                <Column  field="datecontractends" header={$t('dateContractEnd')} body={DatecontractendsTemplate} sortable={true} ></Column>
                                                <Column  field="interestrate" header={$t('interestRate')}  sortable={true} ></Column>
                                                <Column  field="loanamount" header={$t('loanAmount')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentamountdue" header={$t('emi')}  sortable={true} ></Column>
                                                <Column  field="loanterm" header={$t('loanTerm')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentfrequency" header={$t('frequency')}  sortable={true} ></Column>
                                                <Column  field="amort_type" header={$t('amortType')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentduedate" header={$t('paymentDuedate')}  sortable={true} ></Column>
                                                <Column  field="disbursementdate" header={$t('disbursementDate')} body={DisbursementdateTemplate} sortable={true} ></Column>
                                                <Column  field="first_emi_date" header={$t('firstEmiDate')} body={FirstEmiDateTemplate} sortable={true} ></Column>
                                                <Column  field="amountdisbursed" header={$t('amountDisbursed')}  sortable={true} ></Column>
                                                <Column  field="chequeno" header={$t('chequeno')}  sortable={true} ></Column>
                                                <Column  field="ac_code" header={$t('acCode')} body={AcCodeTemplate} sortable={true} ></Column>
                                                <Column  field="processingfee" header={$t('processingFee')}  sortable={true} ></Column>
                                                <Column  field="insurancefee" header={$t('insuranceFee')}  sortable={true} ></Column>
                                                <Column  field="ac_closed" header={$t('acClosed')}  sortable={true} ></Column>
                                                <Column  field="cgst" header={$t('cgst')}  sortable={true} ></Column>
                                                <Column  field="igst" header={$t('igst')}  sortable={true} ></Column>
                                                <Column  field="sgst" header={$t('sgst')}  sortable={true} ></Column>
                                                <Column  field="empcode_sale" header={$t('empcodeSale')}  sortable={true} ></Column>
                                                <Column  field="empcode_collection" header={$t('empcodeCollection')}  sortable={true} ></Column>
                                                <Column  field="appove_roleid" header={$t('appoveRoleid')}  sortable={true} ></Column>
                                                <Column  field="unitid" header={$t('unitid')}  sortable={true} ></Column>
                                                <Column  field="chk_ffirstemi" header={$t('chkFfirstemi')}  sortable={true} ></Column>
                                                <Column  field="date_closed" header={$t('dateClosed')}  sortable={true} ></Column>
                                                <Column  field="userid" header={$t('userid')}  sortable={true} ></Column>
                                                <Column  field="lookupmemvw_membername" header={$t('membername')} body={MembernameTemplate}  ></Column>
                                                <Column  field="lookupmemvw_groupname" header={$t('groupname')} body={GroupnameTemplate}  ></Column>
                                                <Column  field="lookupmemvw_empname" header={$t('empname')} body={EmpnameTemplate}  ></Column>
                                                <Column  field="lookupmemvw_userid" header={$t('lookupmemvwUserid')} body={UseridTemplate}  ></Column>
                                                <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                                {/*PageComponentEnd*/}
                                            </DataTable>
                                            <div className="flex justify-content-around font-bold p-3">
                                                <div>Total Loanamount : <Chip label={totalLoanamount} /></div>
                                            </div>
                                        </div>
                                        <PageFooter />
                                    </div>
                                    {
                                    (currentRecord && !props.isSubPage) && 
                                    <div className="col-12">
                                        <div className="card p-0">
                                            <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
	);
}
GrouploancontractListPage.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'grouploancontract',
	apiPath: 'grouploancontract/index',
	routeName: 'grouploancontractlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default GrouploancontractListPage;
